module.exports = __webpack_public_path__ + "img/image_body-point_01_01.2d9c1054.svg";